module.exports = __webpack_public_path__ + "media/images/author/author-1-04ee784f53cbe427d36231471186eab6.jpg";